<div class="message-board">
    <!-- HERO / HEADER -->
    
    @if (!hasAnyFilter()) {
        <section class="gallery-hero" aria-labelledby="galleryTitle">
            <h1 id="galleryTitle" class="hero-title" [style.viewTransitionName]="'title'">
                Messages and moments that lift us up
            </h1>
            <p class="hero-subtitle">
                Explore heartfelt cards, art, and words from people who care.
            </p>
        
        </section>
    }
    
    <!-- filters-content (brand header) -->
    @if (hasAnyFilter()) {
        <div class="filters-content brand-header" aria-label="Venue header">
            <button class="back-btn" (click)="clearAllFilters()">← Back</button>

            <div class="brand-row">
                <div class="brand-visual">
                    @if (brandLogoUrl()) {
                        <img
                            [src]="brandLogoUrl()"
                            alt="Logo of {{ venueDisplayName() || filters().creditTo }}"
                            class="brand-logo"
                            [style.viewTransitionName]="'brand-logo'"/>
                    } @else {
                        <div class="brand-fallback" [style.viewTransitionName]="'brand-logo'">
                            @switch (true) {
                                @case (!!filters().location) {
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">location_on</span>
                                }
                                @case (!!filters().creditTo) {
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">favorite</span>
                                }
                                
                                @case (!!filters().tab) {
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">label</span>
                                }
                            }
                            <!-- {{ (venueDisplayName() || filters().creditTo || '').charAt(0) }} -->
                        </div>
                    }
                </div>

                <div class="brand-main">
                    <h1 id="galleryTitle" class="hero-title" [style.viewTransitionName]="'title'">
                        {{ venueDisplayName() || filters().creditTo || filters().location || filters().tab }}
                    </h1>

                    <div class="brand-meta">
                        <!-- @if (filters().location) {
                            <span class="meta-item">
                                <span class="material-symbols-outlined sm" aria-hidden="true">location_on</span>
                                <span class="label">{{ filters().location }}</span>
                            </span>
                        } -->

                        <span class="meta-item">
                            <span class="material-symbols-outlined sm" aria-hidden="true">image</span>
                            <span class="label">{{ totalCount() | number }} cards</span>
                        </span>

                        @if (lastUpdated()) {
                            <span class="meta-item">
                                <span class="material-symbols-outlined sm" aria-hidden="true">schedule</span>
                                <span class="label">{{ lastUpdated() | date:'mediumDate' }}</span>
                            </span>
                        }
                    </div>

                    <div class="share-wrapper">
                        <button
                            #shareTrigger
                            class="chip share-trigger"
                            type="button"
                            (click)="toggleShareOptions()"
                            (keydown)="onShareTriggerKeydown($event)"
                            [attr.aria-expanded]="isShareOptionsOpen()"
                            aria-haspopup="menu"
                            title="Share">
                            <span class="material-symbols-outlined sm" aria-hidden="true">ios_share</span>
                            <span class="label">Share</span>
                        </button>

                        @if (isShareOptionsOpen()) {
                            <div class="share-popover" role="menu" (click)="$event.stopPropagation()" #sharePopover>
                                <button class="share-item" type="button" (click)="copyFromPopover()" title="Copy link">
                                    <span class="material-symbols-outlined" aria-hidden="true">
                                        {{ isCopied() ? 'library_add_check' : 'content_copy' }}
                                    </span>
                                    <div class="text">
                                        <span class="title">{{ isCopied() ? 'Copied' : 'Copy link' }}</span>
                                        <span class="hint">The link will be copied to clipboard</span>
                                    </div>
                                </button>

                                <a
                                    class="share-item"
                                    [href]="buildShareLink('twitter')"
                                    target="_blank"
                                    rel="noopener noreferrer me"
                                    aria-label="Share on X (Twitter)"
                                    title="Share on X"
                                    role="menuitem">
                                    <img src="assets/svg/twitter.svg" alt="Twitter">
                                    <div class="text"><span class="title">X (Twitter)</span></div>
                                </a>

                                <a
                                    class="share-item"
                                    [href]="buildShareLink('facebook')"
                                    target="_blank"
                                    rel="noopener noreferrer me"
                                    aria-label="Share on Facebook"
                                    title="Share on Facebook"
                                    role="menuitem">
                                    <img src="assets/svg/fb.svg" alt="Facebook">
                                    <div class="text"><span class="title">Facebook</span></div>
                                </a>

                                <a
                                    class="share-item"
                                    [href]="buildShareLink('linkedin')"
                                    target="_blank"
                                    rel="noopener noreferrer me"
                                    aria-label="Share on LinkedIn"
                                    title="Share on LinkedIn"
                                    role="menuitem">
                                    <img src="assets/svg/linkedin.svg" alt="LinkedIn">
                                    <div class="text"><span class="title">LinkedIn</span></div>
                                </a>

                                <button class="share-item only-web-share" type="button" (click)="shareNative()" title="Share via system dialog">
                                    <span class="material-symbols-outlined" aria-hidden="true">share</span>
                                    <div class="text"><span class="title">System share</span></div>
                                </button>
                            </div>
                        }
                    </div>

                </div>
            </div>
        </div>
        <div class="mini-header" [class.visible]="isMiniHeaderVisible()">
            <div class="mini-inner">
                <div class="mini-left">
                    @if (brandLogoUrl()) {
                        <img
                            class="mini-logo"
                            [src]="brandLogoUrl()"
                            alt="Logo of {{ venueDisplayName() || filters().creditTo }}"
                            [style.viewTransitionName]="'brand-logo'"/>
                    } @else {
                        <div class="mini-fallback">
                            {{ (venueDisplayName() || filters().creditTo || filters().location || filters().tab) }}
                        </div>
                    }
                    @if (brandLogoUrl()) {
                        <span class="mini-title">{{ venueDisplayName() || filters().creditTo }}</span>
                    }
                </div>
                <div class="mini-right">
                    <span class="mini-meta">{{ totalCount() | number }} cards</span>
                </div>
            </div>
        </div>
    }

    
    @if (!hasAnyFilter()) {
        <section
            class="filters-block"
            [style.position]="hasAnyFilter() ? 'relative' : 'sticky'"
            aria-label="Search and filters">
            <div
                [class.hidden]="hasAnyFilter()"
                class="hero-tabs"
                aria-label="Categories"
                role="tablist">
                <w-autocomplete
                    [isAllInfo]="true"
                    placeholder="Search by location, credit to, or tag"
                    emptyHint="Type to search"
                    [class.short-autocomplete]="!isSearchActive()"
                    (select)="applyTextFilter($event)"
                    (inputChange)="null" 
                    (click)="onAutocompleteClick()" />

                @if (isSearchActive()) {
                    @if ((voicesService.getPopularSuggestions() | async); as popular) {
                        <div class="autocomplete-chips">
                            @for (key of [0,1,2]; track key; let i = $index) {
                                <div
                                    class="autocomplete-chips__chip"
                                    [style.--i]="0.1 + (i * 0.2) + 's'"
                                    (click)="
                                        applyTextFilter({ 
                                            key: 'location', 
                                            value: popular!.location[key] 
                                        })
                                    ">
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">location_on</span>
                                    {{ popular!.location[key] }}
                                </div>
                                <div 
                                    class="autocomplete-chips__chip" 
                                    [style.--i]="0.2 + (i * 0.3) + 's'"
                                    (click)="
                                        applyTextFilter({ 
                                            key: 'creditTo', 
                                            value: popular!.creditTo[key] 
                                        })
                                    ">
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">favorite</span>
                                    {{ popular!.creditTo[key] }}
                                </div>
                                <div 
                                    class="autocomplete-chips__chip"
                                    [style.--i]="0.3 + (i * 0.4) + 's'"
                                    (click)="
                                        applyTextFilter({ 
                                            key: 'tab', 
                                            value: popular!.tag[key] 
                                        })
                                    ">
                                    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">label</span>
                                    {{ popular!.tag[key] }}
                                </div>
                            }
                        </div>
                    }
                }
    
                @for (tab of tabs; track tab) {
                    <button
                        [class.hidden]="isSearchActive()"
                        [class.active]="tab === activeTab()"
                        [attr.aria-selected]="tab === activeTab()"
                        (click)="selectTab(tab)"
                        role="tab"
                        type="button">
                        {{ tab }}
                    </button>
                }
    
            </div>
            <!-- @if (hasAnyFilter()) {
                <div class="chips-row" aria-live="polite">
                    @if (filters().location) {
                        <button class="chip" type="button" (click)="applyTextFilter({ key: 'location', value: '' })">
                            <span class="material-symbols-outlined sm" aria-hidden="true">location_on</span>
                            <span class="label">{{ filters().location }}</span>
                            <span class="x" aria-label="Remove location">×</span>
                        </button>
                    }
                    @if (filters().creditTo) {
                        <button class="chip" type="button" (click)="applyTextFilter({ key: 'creditTo', value: '' })">
                            <span class="material-symbols-outlined sm" aria-hidden="true">favorite</span>
                            <span class="label">{{ filters().creditTo }}</span>
                            <span class="x" aria-label="Remove credit">×</span>
                        </button>
                    }
                    @if (activeTab() !== 'All') {
                        <button class="chip" type="button" (click)="applyTextFilter({ key: 'tab', value: 'All' })">
                            <span class="material-symbols-outlined sm" aria-hidden="true">label</span>
                            <span class="label">{{ filters().tab }}</span>
                            <span class="x" aria-label="Remove tag">×</span>
                        </button>
                    }
                </div>
            } -->
        </section>
    }

    @if (!isLoading() && cards().length === 0) {
        <div class="empty-state" aria-live="polite">
            <div class="illus" aria-hidden="true">
                <svg viewBox="0 0 64 64" width="68" height="68">
                    <defs>
                        <linearGradient id="glow" x1="0" x2="1">
                            <stop offset="0" stop-color="#cfd4da" />
                            <stop offset="1" stop-color="#e9ecef" />
                        </linearGradient>
                    </defs>
                    <circle cx="28" cy="28" r="14" fill="url(#glow)" />
                    <circle cx="28" cy="28" r="12" fill="none" stroke="#adb5bd" stroke-width="2" />
                    <rect x="38" y="38" width="18" height="6" rx="3" fill="#ced4da" transform="rotate(48 40 40)"></rect>
                </svg>
            </div>
    
            <h3>No matches yet</h3>
            <p>Try adjusting filters or change the tag logic.</p>
    
            <div class="actions">
                <button class="btn primary" type="button" (click)="clearAllFilters()">Reset filters</button>
            </div>
    
            @if (hasAnyFilter()) {
                <div class="tips">
                    @if (filters().location) {
                        <span
                            class="tip"
                            (click)="applyTextFilter({ key: 'location', value: ''})">
                            Remove location
                        </span>
                    }
                    <!-- @if (filters().description) {
                        <span class="tip" (click)="applyTextFilter({ key: 'description', value: ''})">Remove description</span>
                    } -->
                    @if (filters().creditTo) {
                        <span
                            class="tip"
                            (click)="applyTextFilter({ key: 'creditTo', value: ''})">
                            Remove credit
                        </span>
                    }
                    @if (filters().tab) {
                        <span
                            class="tip"
                            (click)="applyTextFilter({ key: 'tab', value: 'All'})">
                            Remove #{{ filters().tab }}
                        </span>
                    }
                </div>
            }
        </div>
    }

    @if (!isLoading()) {
        <div class="card-grid">
            @for (card of cards(); track card; let i = $index) {
                <div
                    class="card"
                    [style]="'--i: 0.02s'"
                    (mouseenter)="mouseEnterCard(card.id)">
                    <div class="card-image-wrap" (click)="openVoicePage(card.id)" >
                        @if (isGenericVoice(card)) {
                            <button
                                type="button"
                                class="generic-badge"
                                [class.is-clickable]="hasLinkedSupportRequest(card)"
                                [disabled]="!hasLinkedSupportRequest(card)"
                                title="Open the support request this voice came from"
                                aria-label="Open the support request this voice came from"
                                (click)="openLinkedRequest(card, $event)">
                                <span class="material-symbols-outlined" aria-hidden="true">person</span>
                                <span class="label">{{ linkedRequestBadgeLabel }}</span>
                            </button>
                        }
                        <img
                            class="card-image"
                            [src]="card.img"
                            alt="card image" 
                            [style.viewTransitionName]="
                                activeImageId() === card.id ? computedViewImg(card.id) : 'none'
                            "/>
                    </div>
                    <div class="card-content">
                        <div 
                            class="wrap-category" 
                            [style.viewTransitionName]="
                                activeImageId() === card.id ? computedViewTag(card.id) : 'none'
                            ">
                            @if (card.category) {
                                <span
                                    class="category"
                                    (click)="selectTab(card.category)">
                                    {{ card.category }}
                                </span>
                            }
                            @for (tag of card.what; track tag) {
                                <span 
                                    class="category"
                                    (click)="selectTab(tag)">
                                    {{ tag }}
                                </span>
                            }
                            @for (tag of card.express; track tag) {
                                <span 
                                    class="category"
                                    (click)="selectTab(tag)">
                                    {{ tag }}
                                </span>
                            }
                        </div>
                        <h2
                            (click)="openVoicePage(card.id)"
                            class="card-title">
                            {{ card.location }}
                        </h2>
                    </div>
                </div>
            }
        </div>

        @if (isFetchingMore()) {
            <div class="infinite-loader">
                <div class="loader-wave">
                    <div class="wave-dot"></div>
                    <div class="wave-dot"></div>
                    <div class="wave-dot"></div>
                    <div class="wave-dot"></div>
                    <div class="wave-dot"></div>
                </div>
            </div>
        }
        @if (hasMore()) {
            <div #sentinel class="sentinel" aria-hidden="true"></div>
        }
    } @else {
        <div class="content">
            <div class="loader-wave">
                <div class="wave-dot"></div>
                <div class="wave-dot"></div>
                <div class="wave-dot"></div>
                <div class="wave-dot"></div>
                <div class="wave-dot"></div>
            </div>
        </div>
    }
</div>


<div class="preload" aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;">
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">rotate_right</span>
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">rotate_left</span>
    <span class="material-symbols-outlined sm opt-ico" aria-hidden="true">location_on</span>
</div>
